import { useEffect } from 'react';
import { useLocation } from '@react-router';
import type { FormikProps } from 'formik';
import { useRouterHelper, useTranslation } from '@shared/core';
import { useContactCollectorGuestTelemetry } from '../../ContactCollectorGuest.telemetry';
import { withWindow } from '@shared/utils/withWindow';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import { contactCollectorGuestRoutePaths } from '../../contactCollectorGuest.routes';
import type { Contacts } from '../../shared/types';

export const useDoneController = (formik: FormikProps<Contacts>, website: string) => {
  const isMobile = useIsMobileScreen();
  const routeHelpers = useRouterHelper();
  const location = useLocation();
  const { buttonInteracted } = useContactCollectorGuestTelemetry();
  const { t } = useTranslation('contactCollector');
  const tAdmin = t('admin');

  useEffect(() => {
    if (!formik.isValid) routeHelpers.goToExactRoute(contactCollectorGuestRoutePaths.landing.path, location.search);
  }, [formik.isValid, routeHelpers, location.search]);

  const handleOnVisitEventWebsiteClick = () => {
    buttonInteracted({ buttonType: 'navigation', element: 'visitEventWebsite' });
    withWindow(() => {
      window.open(`${window.location.origin}/${website}`, '_blank');
    });
  };

  return {
    tAdmin,
    handleOnVisitEventWebsiteClick,
    isMobile,
  };
};
